<script setup lang="ts">
/**
 * Avatar — the brand initials circle (or a profile image). Default slot holds the initials or an
 * <img>. Consolidates the emerald circle re-implemented across UserMenu / ProfileMenuContent.
 */
interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg'
}
const props = withDefaults(defineProps<Props>(), { size: 'md' })

const sizeClass = {
  xs: 'h-6 w-6 text-[11px]',
  sm: 'h-8 w-8 text-sm',
  md: 'h-9 w-9 text-sm',
  lg: 'h-14 w-14 text-lg',
}
</script>

<template>
  <span
    class="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary-600 font-semibold text-white"
    :class="sizeClass[props.size]"
  >
    <slot />
  </span>
</template>
